import { locationService } from '../_services';

export const locations = {
  namespaced: true,
  state: {
    all: [
      {
        created_at: '',
        id: 0,
        latitude: 0,
        longitude: 0,
        tourid: 0
      }
    ],
    todaysLast: [
      {
        created_at: '',
        id: 0,
        latitude: 0,
        longitude: 0,
        tourid: 0
      }
    ],
    loadnoSpecific: [{}]
  },
  actions: {
    getAll({ commit }, { perpage, page, sortby, descending }) {
      commit('getAllRequest');

      locationService
        .getAll(perpage, page, sortby, descending)
        .then(
          locations => commit('getAllSuccess', locations),
          error => commit('getAllFailure', error)
        );
    },
    getTodaysLast({ commit }) {
      commit('getTodaysLastRequest');

      locationService
        .getTodaysLast()
        .then(
          locations => commit('getTodaysLastSuccess', locations),
          error => commit('getTodaysLastFailure', error)
        );
    },
    getLoadnoSpecific({ commit }, { loadno }) {
      commit('getLoadnoSpecific');

      locationService
        .getLoadnoSpecific(loadno)
        .then(
          locations => commit('getLoadnoSpecific', locations),
          error => commit('getTodaysLastFailure', error)
        );
    }
  },
  mutations: {
    getAllRequest(state) {
      state.all = { loading: true };
    },
    getAllSuccess(state, locations) {
      state.all = { items: locations };
    },
    getAllFailure(state, error) {
      state.all = { error };
    },
    getTodaysLastRequest(state) {
      state.todaysLast = { loading: true };
    },
    getTodaysLastSuccess(state, locations) {
      state.todaysLast = { items: locations };
    },
    getTodaysLastFailure(state, error) {
      console.log(error);
      state.todaysLast = { error };
    },
    getLoadnoSpecific(state, locations) {
      state.loadnoSpecific = { items: locations };
    }
  }
};
